/**
 * Navěšení obsluhy keydown na prvky role="button" s tabindex="0" a data-keydown-control-click
 * Pokud na takovém prvku zmáčknu enter nebo mezerník, tak se vykoná click event
 * Používáme na prvcích, kde máme navěšen jiný JS, který vyžaduje click, aby byl takový prvek přístupný a klikatelný pro nevidomé
 */
import roleButtonKeyboardControl from '../../../../../_shared/js/utils/roleButtonKeyboardControl';

function initRoleButtonKeyboardControl(element) {
	element.querySelectorAll('[data-keydown-control-click][role="button"][tabindex="0"]').forEach((el) => {
		roleButtonKeyboardControl(el);
	});
}

export default function () {
	$.nette.ext('roleButtonKeyboardControl', {
		init: function () {
			initRoleButtonKeyboardControl(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initRoleButtonKeyboardControl($el.get(0));
				}
			});
		}
	});
}
